import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { AuthenticationService } from 'src/app/services/authentication.service'
import { GlobalService } from 'src/app/services/global.service'

@Component({
    selector: 'sales-manager-header',
    templateUrl: './sales-manager-header.component.html',
    styleUrls: ['./sales-manager-header.component.scss'],
})
export class SalesManagerHeaderComponent implements OnInit {
    constructor(public globalService: GlobalService, public authService: AuthenticationService, private router: Router) {}

    ngAfterViewInit() {
        document.addEventListener('click', this.closeContextMenu.bind(this))
    }

    ngOnInit(): void {}

    closeContextMenu(event: MouseEvent) {
        this.globalService.hideContextMenu()
    }

    signOut() {
        this.authService.signOut().then(() => {
            this.router.navigate([''])
        })
    }
}

